export default __webpack_public_path__ + "static/media/it orange.a2257078.png";